module.exports = __webpack_public_path__ + "img/calendar-14_fill.b748edd1.svg";